import { AbiParametersToPrimitiveTypes } from "abitype";

export const LOAN_TERMS_V2_ABI = [
  {
    type: "tuple",
    components: [
      { name: "expiration", type: "uint64" },
      { name: "borrower", type: "address" },
      { name: "currencyToken", type: "address" },
      { name: "collateralToken", type: "address" },
      {
        name: "repaymentSpec",
        type: "tuple",
        components: [
          { name: "totalDurationDays", type: "uint16" },
          { name: "day", type: "uint8" },
          { name: "timezoneOffsetSeconds", type: "int32" },
        ],
      },
      {
        name: "interestRateSpec",
        type: "tuple",
        components: [
          { name: "model", type: "address" },
          { name: "options", type: "bytes" },
        ],
      },
      { name: "collateralTokenIds", type: "uint256[]" },
      {
        name: "trancheSpecs",
        type: "tuple[]",
        components: [
          { name: "lender", type: "address" },
          { name: "amount", type: "uint256" },
          { name: "rate", type: "uint256" },
        ],
      },
      {
        name: "feeSpecs",
        type: "tuple[]",
        components: [
          { name: "kind", type: "uint8" },
          { name: "recipient", type: "address" },
          { name: "model", type: "address" },
          { name: "options", type: "bytes" },
        ],
      },
      { name: "approvalAddresses", type: "address[]" },
      { name: "options", type: "bytes" },
    ],
  },
] as const;

export type LoanTermsV2AbiStruct = AbiParametersToPrimitiveTypes<typeof LOAN_TERMS_V2_ABI>[0];
